import { render, staticRenderFns } from "./IntegrationsList.vue?vue&type=template&id=0a3a5a4e&"
import script from "./IntegrationsList.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsList.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports